exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".react-datepicker-wrapper,\r\n.react-datepicker__input-container,\r\n.react-datepicker__input-container input {\r\n    display: block;\r\n    width: 100%;\r\n}\r\n\r\n.react-datepicker__month-select,\r\n.react-datepicker__month-dropdown-container--select {\r\n    display: inline-block;\r\n    margin: 2px;\r\n    width: 60%;\r\n}\r\n\r\n.react-datepicker__year-select,\r\n.react-datepicker__year-dropdown-container--select {\r\n    display: inline-block;\r\n    margin: 2px;\r\n    width: 45%;\r\n}\r\n\r\n/* Align datepicker with .field-group labels like other form controls */\r\n.field-group .react-datepicker-wrapper {\r\n    display: inline-block;\r\n    width: calc(100% - 135px);\r\n    vertical-align: top;\r\n}\r\n\r\n.field-group .react-datepicker__input-container,\r\n.field-group .react-datepicker__input-container .form-control {\r\n    width: 100%;\r\n}\r\n\r\n@media (max-width: 1199px) {\r\n    .field-group .react-datepicker-wrapper {\r\n        width: 100%;\r\n    }\r\n}\r\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./ClientApp/components/common/DatePicker.css
// module id = 377
// module chunks = 0